<script>
  import { _ } from 'svelte-i18n'
  import { user, modals, server_path } from '../../stores'
  import { onMount } from 'svelte'
  import { runUserDataRoutine } from '../../services/user';
  import queryString from 'query-string'
  import axios from 'axios'
  import Fieldset from '../../elements/Fieldset.svelte'
  import Label from '../../elements/Label.svelte'
  import Input from '../../elements/Input.svelte'
  import Button from '../../elements/Button.svelte'
  import FormError from '../../elements/FormError.svelte'
  import Modal from '../../elements/Modal.svelte'

  let modal_id = 'resetPassword'
  let button_busy = false
  let form_element
  let passwords_match_error = false
  let reset_error = false
  let show_success = false
  let password_token

  onMount(() => {
    let qs = queryString.parse(window.location.search)
    if (qs.password_token) {
      password_token = qs.password_token
      checkToken()
    }
	})

  async function checkToken() {
    axios.post($server_path + 'user/check_password_reset_token.php?password_token=' + password_token, {withCredentials: true})
    .then((response) => {
      if (!$user) {
        if (response.data === true) {
          modals.open('resetPassword')
        } else {
          modals.open('passwordTokenExpired')
        }
      }
    }, (error) => {
      console.log("Query String - could bot check password reset token");
      // bugsnag here
    });
  }

  async function handleSubmit(event) {
    passwords_match_error = reset_error = false
    if (event.target.password1.value !== event.target.password2.value) {
      passwords_match_error = true
      return
    }
    button_busy = true
    
    let form_data = new FormData()
    form_data.append('password', event.target.password1.value)
    
    axios.post($server_path + 'user/set_password.php?password_token=' + password_token, form_data, {withCredentials: true})
    .then((response) => {
      button_busy = false
      if (response.data === false) reset_error = true
      else { 
        // reset success, log in user
        runUserDataRoutine(response.data )
        show_success = true;  
      }
    }, (error) => {
      reset_error = true
      button_busy = false
      console.log("Error with reset post request");
      // bugsnag here
    });
  }

</script>

<Modal id={modal_id}>
  <span slot="header">
    { show_success ? $_('modals.reset.titleSuccess') : $_('modals.reset.title')}
  </span>
  <span slot="content">
    <FormError bind:visible={passwords_match_error}>{$_('modals.reset.passwordsMatchError')}</FormError>
    <FormError bind:visible={reset_error}>{@html $_('modals.reset.resetError')}</FormError>
    
    {#if !show_success}
      <p>{$_('modals.reset.intro')}</p>
      <form bind:this={form_element} on:submit|preventDefault="{handleSubmit}">
        <Fieldset>
          <Label name="password1">{$_('forms.newPassword')}</Label>
          <Input type="password" name="password1" required={true} autocomplete="new-password" focused={true}/>
        </Fieldset>
        <Fieldset>
          <Label name="password2">{$_('forms.confirmNewPassword')}</Label>
          <Input type="password" name="password2" required={true} autocomplete="new-password"/>
        </Fieldset>
        <Button kind="accent" type="submit" busy={button_busy}>{$_('buttons.resetPassword')}</Button>
      </form>
    {:else}
      <p>{$_('modals.reset.success')}</p>
      <Button kind="accent" on:click={() => modals.close()}>{$_('buttons.ok')}</Button>
    {/if}
  </span>
</Modal>

<style>
  p { 
    margin-bottom: 2.5rem;
  }
</style>